import * as React from "react";

import { Margins, SkeletonGenerator } from "@ui/Atoms";
import { BlockPageSkeleton } from "@ui/Skeletons/Skeletons";

const PageSkeleton = React.memo(() => (
  <Margins xs={["base_x3", null, null, null]}>
    <div>
      <BlockPageSkeleton />
    </div>
  </Margins>
));

PageSkeleton.displayName = "PageSkeleton";

const SidebarSkeleton = React.memo(() => (
  <SkeletonGenerator
    count={2}
    shape="rectVertical"
    randomHeight={120}
    noGutter
  />
));
SidebarSkeleton.displayName = "SidebarSkeleton";

export { SidebarSkeleton, PageSkeleton };
